"use strict";

var _assertThisInitialized = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ArweaveUtils = require("./utils");

var BaseObject =
/*#__PURE__*/
function () {
  function BaseObject() {
    _classCallCheck(this, BaseObject);
  }

  _createClass(BaseObject, [{
    key: "get",
    value: function get(field, options) {
      if (!Object.getOwnPropertyNames(this).includes(field)) {
        throw new Error("Field \"".concat(field, "\" is not a property of the Arweave Transaction class."));
      }

      if (options && options.decode == true) {
        if (options && options.string) {
          return ArweaveUtils.b64UrlToString(this[field]);
        }

        return ArweaveUtils.b64UrlToBuffer(this[field]);
      }

      return this[field];
    }
  }]);

  return BaseObject;
}();

var Tag =
/*#__PURE__*/
function (_BaseObject) {
  _inherits(Tag, _BaseObject);

  function Tag(name, value) {
    var _this;

    var decode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, Tag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tag).call(this));
    _this.name = name;
    _this.value = value;
    return _this;
  }

  return Tag;
}(BaseObject);

exports.Tag = Tag;

var Transaction =
/*#__PURE__*/
function (_BaseObject2) {
  _inherits(Transaction, _BaseObject2);

  function Transaction() {
    var _this2;

    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Transaction);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Transaction).call(this));
    _this2.id = "";
    _this2.last_tx = "";
    _this2.owner = "";
    _this2.tags = [];
    _this2.target = "";
    _this2.quantity = "0";
    _this2.data = "";
    _this2.reward = "0";
    _this2.signature = "";
    Object.assign(_assertThisInitialized(_this2), attributes);

    if (attributes.tags) {
      _this2.tags = attributes.tags.map(function (tag) {
        return new Tag(tag.name, tag.value);
      });
    }

    return _this2;
  }

  _createClass(Transaction, [{
    key: "addTag",
    value: function addTag(name, value) {
      this.tags.push(new Tag(ArweaveUtils.stringToB64Url(name), ArweaveUtils.stringToB64Url(value)));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        last_tx: this.last_tx,
        owner: this.owner,
        tags: this.tags,
        target: this.target,
        quantity: this.quantity,
        data: this.data,
        reward: this.reward,
        signature: this.signature
      };
    }
  }, {
    key: "setSignature",
    value: function setSignature(_ref) {
      var signature = _ref.signature,
          id = _ref.id;
      this.signature = signature;
      this.id = id;
    }
  }, {
    key: "getSignatureData",
    value: function getSignatureData() {
      var tagString = this.tags.reduce(function (accumulator, tag) {
        return accumulator + tag.get("name", {
          decode: true,
          string: true
        }) + tag.get("value", {
          decode: true,
          string: true
        });
      }, "");
      return ArweaveUtils.concatBuffers([this.get("owner", {
        decode: true,
        string: false
      }), this.get("target", {
        decode: true,
        string: false
      }), this.get("data", {
        decode: true,
        string: false
      }), ArweaveUtils.stringToBuffer(this.quantity), ArweaveUtils.stringToBuffer(this.reward), this.get("last_tx", {
        decode: true,
        string: false
      }), ArweaveUtils.stringToBuffer(tagString)]);
    }
  }]);

  return Transaction;
}(BaseObject);

exports.default = Transaction;